import { queryOptions } from '@tanstack/react-query'

import { authApi } from './auth.api'

export const authQueryKeys = {
  all: ['auth'] as const,
  me: () => [...authQueryKeys.all, 'me'] as const,
  confirmEmail: (token: string) => [...authQueryKeys.all, 'confirm-email', token] as const,
}

export const authQueries = {
  me: () =>
    queryOptions({
      queryKey: authQueryKeys.me(),
      queryFn: ({ signal }) => authApi.me(signal),
    }),

  /**
   * Email confirmation is a "perform once on page load" call, so it's
   * modeled as a query with refetching fully disabled rather than a
   * mutation: a mutation fired from a mount effect never settles visibly
   * under React StrictMode (the simulated unmount detaches the mutation
   * observer, so the component misses the result), while queries dedupe
   * and resubscribe correctly. The lockdown below guarantees the token is
   * POSTed exactly once per session.
   */
  confirmEmail: (token: string) =>
    queryOptions({
      queryKey: authQueryKeys.confirmEmail(token),
      queryFn: () => authApi.confirm(token).then(() => true as const),
      enabled: token !== '',
      retry: false,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }),
}
